import React from "react";
import { Input } from "antd";

import ShortformCard from "../ShortformCard";
import AvailableTodayCard from "../AvailableTodayCard";
import { Field } from "./fields";

/**
 * Step 6 — the two things the worksheet produces.
 *
 * Exceptions are NOT captured here: they belong to the procedure family they
 * qualify and are entered on that row in step 5. This step just shows what they
 * add up to, as the starred first lines of the shortform — the clinic's rule
 * that anything departing from the generally accepted rules is met first.
 */
export default function ReviewStep({ state, onChange }) {
  function set(k, v) { onChange(Object.assign({}, state, { [k]: v })); }
  return (
    <div>
      <div className="bw-card">
        <p className="bw-card-title">Who verified it</p>
        <p className="bw-hint" style={{ marginTop: 0, marginBottom: 12 }}>
          Exceptions are recorded per procedure family in the previous step; they
          appear starred at the top of the shortform below.
        </p>
        <div className="bw-grid">
          <Field label="Verified by">
            <Input value={state.verifiedBy || ""} placeholder="Carrier rep or staff name"
              onChange={function (e) { set("verifiedBy", e.target.value); }} />
          </Field>
          <Field label="Verified on">
            <Input value={state.verifiedOn || ""} placeholder="Sep 02 / 26"
              onChange={function (e) { set("verifiedOn", e.target.value); }} />
          </Field>
        </div>
      </div>

      <ShortformCard state={state} />
      <AvailableTodayCard />
    </div>
  );
}
